import { use } from 'react';
import { createApplicationsPromise } from '../api/applicationsPromise';
import { guardedClient } from '../../auth/api/clients';

export const useApplications = () => {
  const promise = createApplicationsPromise(guardedClient);
  return use(promise);
};
